import { render, staticRenderFns } from "./ProductApproved.vue?vue&type=template&id=283e0436&"
import script from "./ProductApproved.vue?vue&type=script&lang=js&"
export * from "./ProductApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports